<script setup lang='ts'>
import { computed } from 'vue'
import { screenModule } from '@/store/screen/module'
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    Icon,
} = UIKit

const emit = defineEmits<{
    'createAccount': []
}>()

const breakpoint = computed(() => {
    return screenModule.getters.getBreakpoint()
})

</script>

<template>
    <div class="one-question-down">
        <div class="one-question-down__banner">
            <img
                class="one-question-down__half-tone"
                src="@/assets/register-onboard/try-a-question/banner-half-tone.png"
                alt=""
            />
            <Icon class="one-question-down__star" type="star" />
            <div class="one-question-down__banner-text">
                1576 premium questions to go with stats to track your progress.
            </div>
        </div>
        <img
            v-if="breakpoint === 'black-bear'"
            class="one-question-down__stats-gauge-image"
            src="@/assets/register-onboard/try-a-question/stats-gauge-mobile.png"
            alt=""
        />
        <img
            v-else
            class="one-question-down__stats-gauge-image"
            src="@/assets/register-onboard/try-a-question/stats-gauge-desktop.png"
            alt=""
        />
        <div class="one-question-down__message">
            The more you answer the more you learn where to focus with our recommendations.
        </div>
        <PocketButton
            class="one-question-down__create-account-btn"
            @click="emit('createAccount')"
        >
            Create Account
        </PocketButton>
    </div>
</template>

<style lang='scss' scoped>
.one-question-down {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__banner {
        position: relative;
        display: flex;
        width: 260px;
        padding: 21px 12px 16px 12px;
        flex-direction: column;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid $butterscotch;
        background: $buttermilk;
        margin-top: 24px;
        margin-bottom: 44px;

        @include breakpoint(black-bear) {
            margin-bottom: 32px;
        }
    }

    &__banner-text {
        position: relative;
        z-index: 1;
        margin: 0;
        color: $brand-black;
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;
    }

    &__half-tone {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        pointer-events: none;
    }

    &__star {
        position: absolute;
        top: 4px;
        left: -18px;
        width: 26px;
        height: 26px;
        z-index: 3;
        pointer-events: none;
        color: $caramel;
    }

    &__message {
        width: 258px;
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        margin-top: 40px;

        @include breakpoint(black-bear) {
            margin-top: 32px;
        }
    }

    &__create-account-btn {
        margin-top: 40px;

        @include breakpoint(black-bear) {
            margin-top: 24px;
            margin-bottom: 32px;
        }
    }
}
</style>
